<template>
    <div class="modal fade text-left" id="historyItemModal" tabindex="3" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel1">{{ $t("labels.editHistoryItem") }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="therapyStart">{{ $t("labels.startDate") }}</label>
                                <date-picker v-model="item['startDate']" :lang="$i18n.locale" width="100%" :popupStyle="{top: 30, left: 0}" type="date" format="DD/MM/YYYY" confirm></date-picker>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="therapyStart">{{ $t("labels.endDate") }}</label>
                                <date-picker v-model="item['endDate']" :lang="$i18n.locale" width="100%" :popupStyle="{top: 30, left: 0}" type="date" format="DD/MM/YYYY" confirm></date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="actualDrug">{{ $t("labels.drugs") }}</label>
                                
                                <model-list-select :list="drugs"
                                    v-model="selectedDrug"
                                    option-value="_id"
                                    :custom-text="drugName"
                                    placeholder="select drug">
                                </model-list-select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="projectinput2">{{ $t("labels.bloodLevel") }}</label>
                                <div class="input-group">
                                    <input type="number" min="0" class="form-control" v-model.number="bloodLevel">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="projectinput2">{{ $t("labels.quantity") }}</label>
                                <div class="input-group">
                                    <input type="number" min="0" class="form-control" v-model.number="quantity">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2">mg/day</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bottom-space">
                        <div class="col-md-12">
                            <label for="drugNotes">{{ $t("labels.drugNotes") }}</label>
                            <textarea class="form-control" id ="drugNotes" v-model="notes" placeholder></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button type="button" class="btn btn-success" @click.prevent="addDrug">
                                <i class="icon-note"></i> {{ this.$t("labels.addDrug") }}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <table class="table table-responsive-sm">
                                <thead>
                                    <tr>
                                    <th>{{ $t("labels.drug") }}</th>
                                    <th>{{ $t("labels.quantity") }}</th>
                                    <th>{{ $t("labels.bloodLevel") }}</th>
                                    <th>{{ $t("labels.drugNotes") }}</th>
                                    <th>{{ $t("labels.actions") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="d in item.drugs" :key="d._id">
                                    <td>{{ d.name[$i18n.locale] ? d.name[$i18n.locale] : d.name['en'] }}</td>
                                    <td>{{ d.quantity }}</td>
                                    <td>{{ d.bloodLevel }}</td>
                                    <td>{{ d.notes }}</td>
                                    <td>
                                        <a class="warning p-0" @click.prevent="removeDrug(d)">
                                            <i class="fa fa-trash font-medium-3 mr-2"></i>
                                        </a>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row bottom-space">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="projectinput2">{{ $t("labels.heightCm") }}</label>
                                <div class="input-group">
                                    <input type="number" class="form-control" v-model.number="item['height']">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2">cm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="projectinput2">{{ $t("labels.weightKg") }}</label>
                                <div class="input-group">
                                    <input type="number" class="form-control" v-model.number="item['weight']">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2">kg</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bottom-space">
                        <div class="col-md-12">
                            <label for="projectinput2">{{ $t("labels.therapyNotes") }}</label>
                            <textarea class="form-control" v-model="item['notes']"></textarea>
                        </div>
                    </div>
                    <div class="form-actions">
                        <button type="button" class="btn btn-success" @click.prevent="$emit('savehistoryitem')">
                            <i class="icon-note"></i> {{ $t("labels.save") }}
                        </button>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeHistoryEditModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'

export default {
    props: ["item","drugs"],
    components: {
        ModelListSelect
    },
    data() {
        return {
            drugErrors: [],
            selectedDrug: {},
            quantity: '',
            bloodLevel: '',
            notes: ''
        }
    },
    methods: {
        addDrug() {
            this.drugErrors = []
            let medication = {}
            let drug = this.drugs.find(d => d._id === this.selectedDrug._id)
            if (!drug) {
                this.drugErrors.push(this.$t("errors.cantBeEmpty", [this.$t("models.drug")]))
            }
            if (typeof this.quantity !== 'number' || this.quantity <= 0) {
                this.drugErrors.push(this.$t("errors.validQuantity", [this.$t("labels.quantity")]))
            }
            if (this.drugErrors.length === 0) {
                medication.id = drug._id
                medication.name = drug.name
                medication.quantity = this.quantity
                medication.bloodLevel = this.bloodLevel
                medication.notes = this.notes
                this.item.drugs.unshift(medication)
                this.drug = ''
                this.quantity = ''
                this.notes = ''
                this.$miniToastr.success(this.$t("flash.drugAdded"))
            } else {
                this.$miniToastr.error(this.drugErrors.toString().split(",").join("<hr/>"))
            }
        },
        removeDrug(e) {
            this.item.drugs = this.item.drugs.filter(function( d ) {
                                                return d.id !== e.id
                                            })
        },
        drugName(drug) {
            return drug.name[this.$i18n.locale] ? drug.name[this.$i18n.locale] : drug.name['en']
        }
    }
}
</script>